import useBenefit from "#/components/dynamic-content/hooks/useGetBenefit"
import { useGetHasProviderTypeInCountry } from "./useGetHasProviderTypeInCountry"

// @ts-expect-error TS(7006) FIXME: Parameter 'countryCode' implicitly has an 'any' ty... Remove this comment to see the full error message
export const useHasProviderFinder = (countryCode) => {
  const benefit = useBenefit()

  const {
    data: hasProviderTypes,
    isLoading: isLoadingProviderTypes,
    isError
  } = useGetHasProviderTypeInCountry(countryCode)
  return (
    !benefit.isLoading &&
    benefit.data?.providerFinder?.showProviderFinder &&
    !isLoadingProviderTypes &&
    !isError &&
    hasProviderTypes?.hasProviders // the hook returns null when the session is expired, so the '?' is necessary here
  )
}
